import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { LoadingPage } from "./LoadingSpinner";
import { useAuth } from "../contexts/AuthContext";
import i18n from "../i18n/config";

const PublicRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingPage message={i18n.t("common.checkingAccess")} />;
  }

  if (isAuthenticated) {
    // Già autenticato: destinazione richiesta, oppure il wizard se c'è un
    // draft della landing prompt-first, oppure la home della dashboard.
    const from =
      location.state?.from?.pathname ||
      (sessionStorage.getItem("pingup-onboarding-mode")
        ? "/bots/new"
        : "/home");
    return <Navigate to={from} replace />;
  }

  return children;
};

export default PublicRoute;
